export default "__VITE_ASSET__e5ec1f92__"